import { render, staticRenderFns } from "./ChangeMyPassword.vue?vue&type=template&id=5908e437&"
import script from "./ChangeMyPassword.vue?vue&type=script&lang=ts&"
export * from "./ChangeMyPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports